/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useUIDSeed } from 'react-uid';
import {
    object, string, arrayOf, shape,
} from 'prop-types';

const urlImage = '//cdn1.1800flowers.com/wcsstore/Flowers/images/2016/aboutUs/';

const PageContent = ({
    classes, buttonText, OurBrandsHarryanddavid,  OurBrandsAboutusWolferman,  OurBrandsAboutusFruitbouquetsv2,  OurBrandsAboutusTpf,  OurBrandsAboutusCheryls,  OurBrandsAboutusBasket,
}) => {
    const seed = useUIDSeed();
    return (
        <div container className={classes.container}>

            <div>
                { OurBrandsHarryanddavid.map((list)  => (
                    <div className={classes.imagelist} key={seed(list)}>
                        <img className={classes.image} src={`${urlImage}${list.img}.jpg`} alt="AboutUsimage_hd" />
                        <img className={classes.logo} src={`${urlImage}${list.logo}.png`} alt="logo_hd" />
                        <div className={classes.left}>{list.description}
                            <button type="submit" className={classes.button}><Link className={classes.BrandsButton} to={list.href}>{buttonText}</Link></button>
                        </div>
                    </div>
                ))}
            </div>

            <div>
                { OurBrandsAboutusWolferman.map((list)  => (
                    <div className={classes.imagelist} key={seed(list)}>
                        <img className={classes.image} src={`${urlImage}${list.img}.jpg`} alt="AboutUsimage_wlf" />
                        <img className={classes.rightlogo} src={`${urlImage}${list.logo}.png`} alt="logo_wlf" />
                        <div className={classes.right}>{list.description}<br />
                            <button type="submit" className={classes.button}><Link className={classes.BrandsButton} to={list.href}>{buttonText}</Link></button>
                        </div>
                    </div>

                ))}
            </div>

            <div>
                { OurBrandsAboutusFruitbouquetsv2.map((list)  => (
                    <div className={classes.imagelist} key={seed(list)}>
                        <img className={classes.image} src={`${urlImage}${list.img}.jpg`} alt="AboutUsimage_fruits" />
                        <img className={classes.logo} src={`${urlImage}${list.logo}.png`} alt="logo_fruits" />
                        <div className={classes.left}>{list.description}
                            <button type="submit" className={classes.button}><Link className={classes.BrandsButton} to={list.href}>{buttonText}</Link></button>
                        </div>
                    </div>
                ))}
            </div>
            <div>
                { OurBrandsAboutusTpf.map((list)  => (
                    <div className={classes.imagelist} key={seed(list)}>
                        <img className={classes.image} src={`${urlImage}${list.img}.jpg`} alt="AboutUsimage_ourBrands" />
                        <img className={classes.rightlogo} src={`${urlImage}${list.logo}.png`} alt="logo_ourBrands" />
                        <div className={classes.right}>{list.description}
                            <button type="submit" className={classes.button}><Link className={classes.BrandsButton} to={list.href}>{buttonText}</Link></button>
                        </div>
                    </div>

                ))}
            </div>
            <div>
                { OurBrandsAboutusCheryls.map((list)  => (
                    <div className={classes.imagelist} key={seed(list)}>
                        <img className={classes.image} src={`${urlImage}${list.img}.jpg`} alt="AboutUsimage_cheryls" />
                        <img className={classes.logo} src={`${urlImage}${list.logo}.png`} alt="logo_cheryls" />
                        <div className={classes.left}>{list.description}<br />
                            <button type="submit" className={classes.button}><Link className={classes.BrandsButton} to={list.href}>{buttonText}</Link></button>
                        </div>
                    </div>
                ))}
            </div>
            <div>
                { OurBrandsAboutusBasket.map((list)  => (
                    <div className={classes.imagelist} key={seed(list)}>
                        <img className={classes.image} src={`${urlImage}${list.img}.jpg`} alt="AboutUsimage_baskets" />
                        <img className={classes.rightlogo} src={`${urlImage}${list.logo}.png`} alt="logo_basktes" />
                        <div className={classes.right}>{list.description}<br />
                            <button type="submit" className={classes.buttonRight}><Link className={classes.BrandsButton} to={list.href}>{buttonText}</Link></button>
                        </div>
                    </div>

                ))}
            </div>

        </div>
    );
};

PageContent.propTypes = {
    classes: object.isRequired,
    buttonText: string.isRequired,
    OurBrandsHarryanddavid: arrayOf(
        shape({
            img: string.isRequired,
            logo: string.isRequired,
            description: string.isRequired,

        }),
    ).isRequired,
    OurBrandsAboutusWolferman: arrayOf(
        shape({
            img: string.isRequired,
            logo: string.isRequired,
            description: string.isRequired,

        }),
    ).isRequired,
    OurBrandsAboutusFruitbouquetsv2: arrayOf(
        shape({
            img: string.isRequired,
            logo: string.isRequired,
            description: string.isRequired,

        }),
    ).isRequired,
    OurBrandsAboutusTpf: arrayOf(
        shape({
            img: string.isRequired,
            logo: string.isRequired,
            description: string.isRequired,

        }),
    ).isRequired,
    OurBrandsAboutusCheryls: arrayOf(
        shape({
            img: string.isRequired,
            logo: string.isRequired,
            description: string.isRequired,

        }),
    ).isRequired,
    OurBrandsAboutusBasket: arrayOf(
        shape({
            img: string.isRequired,
            logo: string.isRequired,
            description: string.isRequired,

        }),
    ).isRequired,
};
export default PageContent;
